import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import EffectUtility from "../../utilities/EffectUtility";
import ContenutoModel from "./models/ContenutoModel";

export default class ContenutoEffect {
    public static async contenutoGet(codice: string): Promise<ContenutoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.contenutoGet;

        return EffectUtility.getToModel<ContenutoModel>(ContenutoModel, endpoint, {
            codice: codice,
            lingua: environment.lang,
        });
    }
}
